import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/news"

export const getNewsList = async (queries = {}) => {
  const query =
    stringify(
      queries,
      {
        skipEmptyString: true,
        skipNull: true
      }
    )

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

